import { useState } from 'react';

import { useHandleAuth } from '../../../../../features/auth/useHandleAuth';
import { useSignUpWizardContext } from '../../../../../features/auth/wizards/signUpWizard.provider';
import { useStores } from '../../../../../stores/useStores';

export function useAuthForm(onSuccess?: () => void) {
  const { authStore } = useStores();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string>();
  const { updateContextData } = useSignUpWizardContext();

  const clearError = () => {
    setError(undefined), updateContextData({ error: '' });
  };

  const { handleAuth } = useHandleAuth(setError, onSuccess);
  const isLoading = authStore.pending('signIn') || authStore.isSigningUp;
  const landingKey = authStore.getLandingKey();

  const onEmailChange = (newEmail: string) => {
    clearError();
    setEmail(newEmail);
  };

  const onPasswordChange = (newPassword: string) => {
    clearError();
    setPassword(newPassword);
  };

  return {
    email,
    password,
    error,
    isLoading,
    landingKey,
    setError,
    clearError,
    onEmailChange,
    onPasswordChange,
    handleAuth,
  };
}
